import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";

import * as selectors from "src/bepaid/store/model/Fetch/selectors";

import View from "./View";

const mapStateToProps = (state: RootState) => ({
  isPersonalAccount: selectors.getIsPersonalAccount(state),
  accountCountryCode: selectors.getAccountCountryCode(state),
  hasWallexPayment: selectors.getHasWallexPayment(state)
});

export type IProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps, null)(View);
